import React from 'react'
import GridCardImage from './GridCardImage'
import labels from '../../configuration/labels'
import renderHTML from 'react-render-html'
import moment from 'moment'
import { get, isEmpty } from 'lodash'

import arrowRight from '../../assets/icons/calendar-next.svg'

const GridCard = ({ eventData }) => {
  let eventStartDate = null
  let eventStartTime = null
  let eventEndDate = null
  let eventEndTime = null

  let eventDateFormat = 'MMMM Do YYYY'
  let eventTimeFormat = 'h:mma'

  if (process.env.REACT_APP_FORMAT_GRID_CARD_EVENT_DATE) {
    eventDateFormat = process.env.REACT_APP_FORMAT_GRID_CARD_EVENT_DATE
  }

  if (process.env.REACT_APP_FORMAT_GRID_CARD_EVENT_TIME) {
    eventTimeFormat = process.env.REACT_APP_FORMAT_GRID_CARD_EVENT_TIME
  }

  const activeStartDate = get(eventData, 'activeDates.startDate', null)
  const activeEndDate = get(eventData, 'activeDates.endDate', null)

  if (activeStartDate) {
    eventStartDate = moment(eventData.activeDates.startDate).format(eventDateFormat)
    eventStartTime = moment(eventData.activeDates.startDate).format(eventTimeFormat)

    if (activeEndDate) {
      if (moment(activeEndDate).isAfter(activeStartDate, 'day')) {
        eventEndDate = moment(eventData.activeDates.endDate).format(eventDateFormat)
      }

      if (
        moment(activeEndDate).isSameOrAfter(activeStartDate, 'day') &&
        moment(activeEndDate).isSameOrAfter(activeStartDate, 'minute')
      ) {
        eventEndTime = moment(eventData.activeDates.endDate).format(eventTimeFormat)
      }
    }
  }

  return (
    <div className="flow-events__grid-card">
      <div className="flow-events__grid-card-image">
        {eventData.marketingLink ? (
          <a
            href={eventData.marketingLink}
            target={!eventData.isInternalLink ? '_blank' : '_self'}
            rel="noopener noreferrer"
          >
            <GridCardImage eventData={eventData} />
          </a>
        ) : (
          <GridCardImage eventData={eventData} />
        )}
      </div>

      <div className="flow-events__grid-card-content">
        {eventData.categories &&
        Array.isArray(eventData.categories) &&
        !isEmpty(eventData.categories) ? (
          <p className="event-categories">{eventData.categories.join(', ')}</p>
        ) : eventData.categories ? (
          <p className="event-categories">{eventData.categories}</p>
        ) : null}

        {eventData.title && (
          <h3 className="event-title">
            {eventData.marketingLink ? (
              <a
                href={eventData.marketingLink}
                target={!eventData.isInternalLink ? '_blank' : '_self'}
                rel="noopener noreferrer"
              >
                {renderHTML(eventData.title)}
              </a>
            ) : (
              renderHTML(eventData.title)
            )}
          </h3>
        )}

        {eventData.flagText && (
          <div className="event-property">
            <p
              className="u-remove-margin"
              style={
                eventData.flagColor && {
                  border: `1px solid ${eventData.flagColor}`,
                  color: `${eventData.flagColor}`,
                }
              }
            >
              {eventData.flagText}
            </p>
          </div>
        )}

        {eventStartDate && (
          <div className="flow-events__grid-card-content-row event-date">
            <p className="label u-remove-margin">{labels.date}:</p>
            <p className="value u-remove-margin">
              {eventStartDate}
              {eventEndDate && ' - ' + eventEndDate}
            </p>
          </div>
        )}

        {eventStartTime && (
          <div className="flow-events__grid-card-content-row event-time">
            <p className="label u-remove-margin">{labels.time}:</p>
            <p className="value u-remove-margin">
              {eventData.isAllDay ? (
                'All Day'
              ) : (
                <>
                  {eventStartTime}
                  {eventEndTime && ' - ' + eventEndTime}
                </>
              )}
            </p>
          </div>
        )}

        {eventData.location && (
          <div className="flow-events__grid-card-content-row event-location">
            <p className="label u-remove-margin">{labels.location}:</p>
            <p className="value u-remove-margin">{eventData.location}</p>
          </div>
        )}

        {eventData.marketingLink && (
          <div className="flow-events__grid-card-content-row event-details-cta">
            <a
              href={eventData.marketingLink}
              target={!eventData.isInternalLink ? '_blank' : '_self'}
              rel="noopener noreferrer"
            >
              {labels.viewDetailsCta}
            </a>
          </div>
        )}

        {eventData.marketingLink && (
          <a
            href={eventData.marketingLink}
            target={!eventData.isInternalLink ? '_blank' : '_self'}
            rel="noopener noreferrer"
            className="event-details-arrow"
          >
            <span className="u-remove-element">{labels.viewDetailsCta}</span>
            <img src={arrowRight} alt="View Event Details" />
          </a>
        )}
      </div>
    </div>
  )
}

export default GridCard
